import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function CertificationSection() {
  const { t } = useTranslation();
  return (
    <section className="relative py-20 md:py-28 bg-primary-900">
      <div className="max-w-[800px] mx-auto px-8">
        <div className="text-center mb-12">
          {String(t('skills.cert.label')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-400 text-[13px] tracking-[0.2em] mb-5 font-label">{__s}</p>))}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-50 tracking-[0.06em] mb-2">
            {t('skills.cert.title')}
          </h2>
          {String(t('skills.cert.titleEn')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="section-title-en text-accent-400 text-[15px] tracking-[0.12em] mb-4">{__s}</p>))}
          <div className="gold-line mx-auto"></div>
        </div>

        <div className="flex flex-col md:flex-row gap-10 items-center">
          <div className="flex-1">
            {String(t('skills.cert.description')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[16px] text-foreground-300 tracking-[0.04em] leading-relaxed mb-4">{__s}</p>))}
            {String(t('skills.cert.note')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[14px] text-foreground-500 tracking-[0.03em] leading-relaxed mb-6">{__s}</p>))}
            <Link
              to="/certificate"
              className="inline-flex items-center gap-2 px-8 py-3 bg-accent-500 hover:bg-accent-400 text-primary-900 text-[15px] tracking-[0.08em] font-medium transition-all duration-300 whitespace-nowrap btn-glow cursor-pointer"
            >
              {t('skills.cert.viewLink')}
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-sm"></i>
              </div>
            </Link>
          </div>

          <div className="flex-shrink-0 w-full md:w-[260px]">
            <div className="bg-primary-800/60 border border-primary-700/50 p-6 text-center">
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                <i className="ri-verified-badge-line text-3xl text-accent-500"></i>
              </div>
              {String(t('skills.cert.badge.title')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="font-heading text-[16px] text-foreground-100 tracking-[0.06em] mb-1">{__s}</p>))}
              {String(t('skills.cert.badge.subtitle')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[13px] text-foreground-400 tracking-[0.04em]">{__s}</p>))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
